<template>
	<div>
        <div class="row h1 page-header">
            Club&nbsp;Events
            <button class="btn btn-primary pull-right" @click="showNewEventForm" v-show="!addMode">Add New Event</button>
            <button class="btn btn-danger pull-right" @click="hideNewEventForm" v-show="addMode">Cancel</button>
    	</div>

		<v-event-form v-if="addMode" @event-changed="reloadEvents()" :currentEvent="currentEvent"></v-event-form>

		<v-events-list ref="eventsList" @event-edit="editEvent($event)"></v-events-list>
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
				addMode: false,
				currentEvent: null
			}
		},

		methods: {
			showNewEventForm() {
				this.addMode = true;
			},

			hideNewEventForm() {
				this.addMode = false;
				this.currentEvent = null;
			},

			reloadEvents() {
				this.addMode = false;
				this.currentEvent = null;
				this.$refs.eventsList.getClubEvents();
			},

			editEvent(event) {
				this.addMode = true;
				this.currentEvent = event;
			}
		}
	}
</script>
